import { render, staticRenderFns } from "./NkTree.vue?vue&type=template&id=52f93966&scoped=true"
import script from "./NkTree.vue?vue&type=script&lang=js"
export * from "./NkTree.vue?vue&type=script&lang=js"
import style0 from "./NkTree.vue?vue&type=style&index=0&id=52f93966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f93966",
  null
  
)

export default component.exports